import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any, searchText: string):any {
    if(value.length === 0 || searchText ==='') {
      return value;
    }

    const resultArray = [];
    for(const item of value) {
      searchText = searchText.toLocaleLowerCase();

      if(item.data.label.toLocaleLowerCase().includes(searchText)){
        resultArray.push(item);
      }
    }
      return resultArray;
    
  }
}
